import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import { SQLite, SQLiteObject } from '@ionic-native/sqlite';

@Injectable()
export class DatabaseProvider {

  constructor(private sqlite: SQLite) {

  }

  /**
   * Cria um banco caso não exista ou pega um banco existente com o nome no parametro
   */
  getDB() {
    return this.sqlite.create({ name: "delivery.db", location: "default" });
  }

  /**
   * Cria a estrutura inicial do banco de dados
   */
  public createDatabase() {
    return this.getDB()
      .then((db: SQLiteObject) => {

        // Criando as tabelas
        this.createTables(db);

        //criando os campos
        this.createFields(db);

      });
    //.catch(e => console.log(e));
  }

  /**
   * Criando as tabelas no banco de dados
   * @param db
   */
  private createTables(db: SQLiteObject) {
    // Criando as tabelas
    db.sqlBatch([
      ['CREATE TABLE IF NOT EXISTS empresas (Emp_Numero integer primary key NOT NULL, Emp_RazaoSocial TEXT, Emp_NomeFantasia TEXT, Emp_CNPJ TEXT, Emp_Cidade TEXT, Emp_UF TEXT)'],
      ['CREATE TABLE IF NOT EXISTS parametros (Par_Codigo TEXT primary key NOT NULL, Par_Tipo TEXT, Par_Valor TEXT)'],
      ['CREATE TABLE IF NOT EXISTS formaspgto (Fpg_Codigo integer primary key NOT NULL, Fpg_Descricao TEXT, Fpg_FormulaPgto TEXT)'],
      ['CREATE TABLE IF NOT EXISTS cartoescredito (Cart_Codigo integer primary key NOT NULL, Cart_Nome TEXT, Cart_Conta TEXT, Cart_Tipo TEXT, Cart_DiasCompensacao INTEGER, Cart_Parcelas integer)'],
      ['CREATE TABLE IF NOT EXISTS produtos (Prod_Codigo integer primary key NOT NULL, Prod_Descricao TEXT, Prod_CodBarra TEXT, Prod_Unidade TEXT, Prod_PrecoVenda REAL, Prod_Estoque REAL)'],
      ['CREATE TABLE IF NOT EXISTS tabelapreco (Tab_Codigo integer primary key NOT NULL, Tab_Nome TEXT)'],
      ['CREATE TABLE IF NOT EXISTS tabelapreco_itens (Tab_Codigo integer NOT NULL, Prod_Codigo integer NOT NULL, Tbi_Valor REAL, PRIMARY KEY(Tab_Codigo, Prod_Codigo))'],
      ['CREATE TABLE IF NOT EXISTS clientes (Cli_Codigo integer primary key NOT NULL, Cli_NomeFantasia TEXT, Cli_RazaoSocial TEXT, Cli_CPFCNPJ TEXT, ' +
        'Cli_RGIE TEXT, Cli_Email TEXT, Cli_Fone1 TEXT, Cli_Fone2 TEXT, Cli_Fax TEXT, Cli_Celular TEXT, Cli_Whats TEXT, Cli_Endereco TEXT, Cli_NroEndereco TEXT, ' +
        'Cli_Bairro TEXT, Cli_Complemento TEXT, Cli_CEP TEXT, Cli_Cidade TEXT, Cli_UF TEXT, Cli_CodMunicipio INTEGER, Cli_Bloquear TEXT,' +
        'Cli_MotivoBloqueio TEXT, Cli_CreditoLiberado TEXT, Cli_LimiteCredito REAL, Cli_VlrDebitos REAL, Cli_BloquearData TEXT, Cli_BloquearLimite TEXT, Cli_UltimoVcto DATE, ' +
        'Cli_UltVenda DATE, Cli_VlrUltimaVenda REAL, Cli_CadastradoApp TEXT, Dev_UUID TEXT, User_Codigo INTEGER)'],
      ['CREATE TABLE IF NOT EXISTS clientes_tabelapreco (Cli_Codigo integer NOT NULL, Tab_Codigo integer NOT NULL, PRIMARY KEY(Cli_Codigo, Tab_Codigo))'],
      ['CREATE TABLE IF NOT EXISTS pedidos (Ped_Numero integer primary key AUTOINCREMENT NOT NULL, Cli_Codigo integer, Ped_Data DATE, Ped_Obs TEXT, User_Codigo integer, Tab_Codigo integer, ' +
        'Fpg_Codigo integer, Ped_VlrTotal REAL, Ped_VlrDesconto REAL, Ped_VlrLiquido REAL, Ped_Sincronizado TEXT, Dev_UUID TEXT)'],
      ['CREATE TABLE IF NOT EXISTS pedidos_itens (Ped_Numero integer NOT NULL, PedI_Item integer NOT NULL, Pro_Codigo integer, PedI_Qtde REAL, PedI_VlrUnit REAL, PedI_VlrDesconto REAL, PedI_VlrTotal REAL, PRIMARY KEY(Ped_Numero, PedI_Item))'],
      ['CREATE TABLE IF NOT EXISTS pedidos_pgto (Ped_Numero integer NOT NULL, Ppg_Seq integer NOT NULL, Ppg_CodFormaPgto integer, Ppg_Descricao TEXT, Ppg_NroDoc TEXT, Ppg_Vcto DATE, Ppg_Valor REAL, Ppg_ValorPago REAL, Ppg_ValorTroco REAL, Ppg_TrocoEmHaver TEXT, ' +
        'Ppg_CodCliente integer, Ppg_NumCheque TEXT, Ppg_Agencia TEXT, Ppg_CC TEXT, Ppg_CPF TEXT, Ppg_NomeCheque TEXT, Ppg_ContaDB TEXT, PRIMARY KEY(Ped_Numero, Ppg_Seq)) '],
      ['CREATE TABLE IF NOT EXISTS rotas (Rot_Codigo integer primary key NOT NULL, Rot_Descricao TEXT)']
    ])
      .then(() => console.log('Tabelas criadas'))
      .catch(e => console.error('Erro ao criar as tabelas', e));
  }

  private fieldExists(db: SQLiteObject, tabela, campo) {
    return db.executeSql('SELECT * FROM sqlite_master WHERE type = ? AND name = ? AND sql LIKE ?',
      ['table', tabela, '%' + campo + '%'])
      .then((data: any) => {
        if (data.rows.length > 0) {
          return true;
        } else {
          return false;
        }
      })
      .catch((e) => {
        console.error(e);
        return false;
      });
  }

  private createFields(db: SQLiteObject) {
    let querys = [];

    //cria campo Cli_Status na tabela clientes
    this.fieldExists(db, 'clientes', 'Cli_Status').then((existe: Boolean) => {
      if (!existe) {
        querys.push('ALTER TABLE clientes ADD COLUMN Cli_Status TEXT');
      }

      //cria campo Tab_Tipo na tabela tabelapreco
      this.fieldExists(db, 'tabelapreco', 'Tab_Tipo').then((existe: Boolean) => {
        if (!existe) {
          querys.push('ALTER TABLE tabelapreco ADD COLUMN Tab_Tipo TEXT');
        }

        //cria campo Fpg_ContaDB na tabela formaspgto
        this.fieldExists(db, 'formaspgto', 'Fpg_ContaDB').then((existe: Boolean) => {
          if (!existe) {
            querys.push('ALTER TABLE formaspgto ADD COLUMN Fpg_ContaDB TEXT');
          }

          //cria campo Rot_Codigo na tabela pedidos
          this.fieldExists(db, 'pedidos', 'Rot_Codigo').then((existe: Boolean) => {
            if (!existe) {
              querys.push('ALTER TABLE pedidos ADD COLUMN Rot_Codigo integer');
            }

            //cria campo Rot_Codigo na tabela clientes
            this.fieldExists(db, 'clientes', 'Rot_Codigo').then((existe: Boolean) => {
              if (!existe) {
                querys.push('ALTER TABLE clientes ADD COLUMN Rot_Codigo integer');
              }

              //cria campo Rot_Codigo na tabela pedidos_pgto
              this.fieldExists(db, 'pedidos_pgto', 'Ppg_CodBanco').then((existe: Boolean) => {
                if (!existe) {
                  querys.push('ALTER TABLE pedidos_pgto ADD COLUMN Ppg_CodBanco TEXT');
                }

                this.fieldExists(db, 'pedidos', 'Ped_CodNFCe').then((existe: Boolean) => {
                  if (!existe) {
                    querys.push('ALTER TABLE pedidos ADD COLUMN Ped_CodNFCe INTEGER');
                  }

                  this.fieldExists(db, 'pedidos', 'Ped_StatusOlimpus').then((existe: Boolean) => {
                    if (!existe) {
                      querys.push('ALTER TABLE pedidos ADD COLUMN Ped_StatusOlimpus TEXT');
                    }

                    //executa sqls
                    if (querys.length > 0) {
                      db.sqlBatch(querys)
                        .then(() => console.log('campos criados'))
                        .catch(e => console.error('Erro ao criar as campos', e));
                    }
                  });
                });
              });
            });
          });
        });
      });

    });

  }
}



// WEBPACK FOOTER //
// ./src/providers/database/database.ts